module.exports = __webpack_public_path__ + "static/media/bg_home_banner_bg.361db78e.svg";